import { useContext } from 'react';
import { DevModeContext } from '@contexts/dev-mode/dev-mode-context';

/**
 * The only way to ask whether dev mode is on. The flag and the stored switch are private to
 * `DevModeProvider`; going around this hook to read either one would gate a feature on half the
 * answer.
 */
export const useDevMode = () => useContext(DevModeContext);
